import React from "react";

// Lazy-loaded import of the FAQS and CMS component using React.lazy
export const FAQS = React.lazy(() => import("./FAQS/index.page"));
export const CmsPages = React.lazy(() => import("./CmsPages/index"));
